import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTimeSlots({ stepId, startDate }) {
  const [timeSlots, setTimeSlots] = useState(null);

  useEffect(() => {
    setTimeSlots(null);

    const offset = startDate.toDate().getTimezoneOffset();
    const formattedDate = new Date(startDate.toDate().getTime() - (offset * 60 * 1000));

    axios
      .get(routes.api.steps.session.schedule(stepId, formattedDate.toISOString().split('T')[0]))
      .then((response) => {
        setTimeSlots(response.data);
      });
  }, [stepId, startDate]);

  return timeSlots;
}
